import { ArrowUpRight } from "lucide-react";
import { useBooking } from "@/booking";

export const Wordmark = () => (
  <a
    href="#top"
    data-testid="nav-wordmark-logo"
    className="font-display text-xl font-extrabold tracking-tight text-violet-700"
  >
    GrowRx
  </a>
);

const LINKS = [
  { label: "How it works", href: "#how" },
  { label: "Results", href: "#results" },
  { label: "FAQ", href: "#faq" },
];

export const NavigationHeader = () => {
  const { openBooking } = useBooking();
  return (
    <header
      data-testid="nav-header"
      className="sticky top-0 z-50 bg-[#FFFFFF]/85 backdrop-blur-lg border-b border-[#F0EBF8]"
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Wordmark />
        <nav className="hidden md:flex items-center gap-8" data-testid="nav-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-[#3B0764] hover:text-violet-700 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <button
          onClick={openBooking}
          data-testid="nav-book-call-cta"
          className="group inline-flex items-center gap-1.5 rounded-full bg-violet-700 px-5 py-2.5 text-sm font-semibold text-white transition-[background-color] duration-300 hover:bg-violet-600"
        >
          Book a Strategy Call
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </button>
      </div>
    </header>
  );
};
